const getCookieParams = (store) => {
	const IS_DEV = process.env.NODE_ENV === 'development';
	return IS_DEV ? {} : store.Session.cookieParams;
};

export default getCookieParams;
